import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, from } from 'rxjs';
import { AppStore } from '../../shared/store/lookup-store.service';

@Injectable({
  providedIn: 'root'
})

export class TaskWizardResolver implements Resolve<any> {
  constructor(private lookupStore: AppStore) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return from(this.lookupStore.loadInitialData());
  }
}
